import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ToastType } from '../../common/enum/toast.enum';
import { Toast } from './interfaces/toast.interface';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new Subject<Toast>();

  public onToast(): Observable<any> {
    return this.toastSubject.asObservable();
  }

  public success(msg: string): void {
    this.show(msg, ToastType.SUCCESS);
  }

  public error(msg: string): void {
    this.show(msg, ToastType.ERROR);
  }

  private show(msg: string, type: ToastType = ToastType.SUCCESS): void {
    this.toastSubject.next({
      msg,
      type,
    });
  }
}
